<template>

<div class="main list-view">

	<div v-if="!showDetail" class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div v-else class="sub-header detail-sub-header">
		<div class="detail-title">{{ listDetail.title }}</div>
	</div>

	<div class="filters">
		<div v-if="showDetail">
			<div :class="['button', canSaveItem ? 'action' : 'disabled']" @click="saveItem()">Save Promo Code</div>
			<div class="button neutral" @click="backToList()">Back to List</div>
		</div>
		<div v-else>
			<label>Type</label>
			<select v-model="filters.promotion_type_id" @change="getList()">
				<option value="">All Types</option>
				<option v-for="type in promotionTypes" :key="type.promotion_type_id" :value="type.promotion_type_id">{{ type.description }}</option>
			</select>
			<label>User Type Required</label>
			<select v-model="filters.user_type_id" @change="getList()">
				<option value="">All Types</option>
				<option v-for="type in userTypes" :key="type.user_type_id" :value="type.user_type_id">{{ type.description }}</option>
			</select>
			<div class="label-group">
				<label>Start</label>
				<input type="date" v-model="filters.start_date">
			</div>
			<div class="label-group">
				<label>End</label>
				<input type="date" v-model="filters.end_date">
			</div>
			<div class="label-group">
				<label></label>
				<div class="button small neutral" @click="getList()">Filter Dates</div>
			</div>
			<div class="divider"></div>
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('internal_use_only')"></span>
					<label>Hidden</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
					<label>Inactive</label>
				</li>
			</ul>
			<div class="divider"></div>

			<div class="button neutral" @click="clearFilters(true)">Clear Filters</div>
			<div class="button action" @click="addItem()">New Promo Code</div>
			<div class="divider"></div>
			<router-link v-if="legacyLink" :to="legacyLink" class="extra-menu-item">Legacy Version</router-link>

		</div>

	</div>

	<loading v-if="loading" class="loading"></loading>

	<div v-else-if="showDetail" class="detail two-columns">
		<div>
			<label-required label="Code" :condition="listDetail.promotion_code" />
			<input type="text" v-model="listDetail.promotion_code" />
			<label-required label="Description" :condition="listDetail.description" />
			<input type="text" v-model="listDetail.description" />
			<label-required label="Type" :condition="listDetail.promotion_type_id" />
			<select v-model="listDetail.promotion_type_id">
				<option value="">Select...</option>
				<option v-for="type in promotionTypes" :key="type.promotion_type_id" :value="type.promotion_type_id">{{ type.description }}</option>
			</select>
			<label>For Logged In User Type</label>
			<select v-model="listDetail.user_type_id">
				<option value="">Select...</option>
				<option v-for="type in userTypes" :key="type.user_type_id" :value="type.user_type_id">{{ type.description }}</option>
			</select>

			<div class="two-columns">
				<div>
					<label>Start Date</label>
					<input type="date" v-model="listDetail.start_date" />
				</div>
				<div>
					<label>End Date</label>
					<input type="date" v-model="listDetail.end_date" />
				</div>
			</div>

			<div class="two-columns">
				<div>
					<label>Minimum Amount</label>
					<input type="number" v-model="listDetail.minimum_amount" min="0" step="0.01" />
				</div>
				<div>
					<label>Minimum Quantity</label>
					<input type="number" v-model="listDetail.minimum_quantity" min="0" step="1" />
				</div>
				<div style="position: relative;">
					<label>Discount Amount</label>
					<input type="number" v-model="listDetail.discount_amount" min="0" step="0.01" />
					<div style="position: absolute; top: 1.5em; right: -2em; padding: 0.25em 0.5em; color: #666;">or</div>
				</div>
				<div>
					<label>Discount Percent</label>
					<input type="number" v-model="listDetail.discount_percent" step="1" />
				</div>
			</div>

			<div class="three-columns">
				<div>
					<label>Code Required</label>
					<binary-toggle v-model="listDetail.code_required" labels="Yes,No" values="1,0" :key="'code_required_' + listDetail.code_required" />
				</div>
				<div>
					<label>Hidden</label>
					<binary-toggle v-model="listDetail.internal_use_only" labels="Yes,No" values="1,0" :key="'internal_use_only_' + listDetail.internal_use_only" />
				</div>
				<div>
					<label>Inactive</label>
					<binary-toggle v-model="listDetail.inactive" labels="Yes,No" values="1,0" :key="'inactive_' + listDetail.inactive" />
				</div>
			</div>
		</div>

		<div>
			<h2>Order History</h2>
			<div class="two-columns v-spaced">
				<div><label>Total Amount Redeemed</label> <b>{{ $formatCurrency(performance.total_amount) }}</b></div>
				<div><label>Total Times Redeemed</label> <b>{{ performance.total_redeemed }}</b></div>
			</div>
			<div v-if="orderHistory.length > 0" class="list">
				Recent Order History
				<div v-for="(order, index) in orderHistory" :key="'order_history_' + index" class="four-columns clickable-list-item" @click="goToOrder(order.order_id)" style="padding: 0.25em 0;">
					<div>{{ order.order_date }}</div>
					<div>{{ order.order_number }}</div>
					<div>{{ order.full_name }}</div>
					<div class="right">{{ $formatCurrency(order.amount) }}</div>
				</div>
			</div>
		</div>
	</div>

	<div v-else class="list">

		<div v-if="list.length == 0" class="empty-list">
			This list is empty
		</div>

		<table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list left">Code</th>
					<th class="list left">Description</th>
					<th class="list left">Type</th>
					<th class="list left">Start Date</th>
					<th class="list left">End Date</th>
					<th class="list center">Hidden</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="$router.push({ path: '/promotions/promo-code-detail/' + item.promotion_id })" :key="'promo_code_' + index">
				<td class="list left">{{ item.promotion_code }}</td>
				<td class="list left">{{ item.description }}</td>
				<td class="list left">{{ item.promotion_type_code.capitalizeWords() }}</td>
				<td class="list left">{{ item.start_date }}</td>
				<td class="list left">{{ item.end_date }}</td>
				<td class="list center"><i v-if="item.internal_use_only" class="fas fa-check"></i></td>
			</tr>
		</table>

	</div>
	
	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" @action="doMessageModalAction()" />

</div>

</template>

<script>
import Loading from '@/components/Loading.vue'
import LabelRequired from '@/components/LabelRequired.vue'
import BinaryToggle from '@/components/BinaryToggle'

export default {
	name: 'promo-codes',
	props: ['promotion_id'],
	components: {
		'loading': Loading,
		'label-required': LabelRequired,
		'binary-toggle': BinaryToggle
	},
	data() {
		return {
			loading: false,
			filters: {},
			list: [],
			paging: {},
			promotionTypes: [],
			userTypes: [],
			showDetail: false,
			listDetail: {},
			message: '',
			saving: false,
			messageStatus: '',
			messageTimeout: 0,
			legacyLink: '',
			performance: {},
			orderHistory: []
		}
	},
	created() {
		this.clearFilters()
		if (this.promotion_id) {
			this.getItem()
		} else {
			this.getList()
		}
	},
	computed: {
		canSaveItem() {
			return this.listDetail.promotion_code && this.listDetail.description && this.listDetail.promotion_type_id
		}
	},
	watch: {
		promotion_id: function() {
			if (this.promotion_id) {
				this.getItem()
			}
		},
		'listDetail.discount_amount': function(newVal) {
			if (newVal && newVal > 0) {
				this.listDetail.discount_percent = ''
			}
		},
		'listDetail.discount_percent': function(newVal) {
			if (newVal && newVal > 0) {
				this.listDetail.discount_amount = ''
			}
		}
	},
	methods: {
		clearFilters(getList = false) {
			this.filters = {
				page: 1,
				promotion_type_id: '',
				user_type_id: '',
				search_term: '',
				start_date: '',
				end_date: '',
				internal_use_only: 0,
				inactive: 0
			}
			if (getList) {
				if (this.promotion_id) {
					this.backToList()
				} else {
					this.getList()
				}
			}
		},
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_list_promo_codes', data: this.filters }).then(obj => {
				this.loading = false
				this.list = obj.list
				if (obj.promotion_types) {
					this.promotionTypes = obj.promotion_types
				}
				if (obj.user_types) {
					this.userTypes = obj.user_types
				}
				if (obj.paging) {
					this.paging = obj.paging
				}
				if (obj.legacy_link) {
					this.legacyLink = obj.legacy_link
				}
			}).catch(err => {
				console.log(err)
			})
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_item_promo_code', data: { promotion_id: this.promotion_id } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.listDetail = obj.detail
					if (obj.performance) {
						this.performance = obj.performance
					}
					if (obj.order_history) {
						this.orderHistory = obj.order_history
					}
					this.showDetail = true
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		addItem() {
			this.listDetail = {
				promotion_id: '',
				promotion_type_id: '',
				user_type_id: '',
				code_required: 0,
				internal_use_only: 0,
				inactive: 0
			}
			this.showDetail = true
		},
		saveItem() {
			if (this.saving) { return false }
			if (!this.canSaveItem) { return false }
			this.saving = true
			this.message = 'Saving promo code...'
			this.messageStatus = ''
			this.messageTimeout = 0
			this.apiCall({ destination: 'save_item_promo_code', data: this.listDetail }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					if (!this.listDetail.promotion_id) {
						this.listDetail.promotion_id = obj.promotion_id
						this.$router.push({ path: '/promotions/promo-code-detail/' + this.listDetail.promotion_id })
					}
					this.message = 'Promo code saved!'
					this.messageTimeout = 2000
				} else {
					this.message = obj.message || 'There was an error saving the promo code.'
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.$router.push({ path: '/promotions/promo-codes' })
			this.getList()
			this.listDetail = {}
			this.showDetail = false
		},
		goToOrder(orderId) {
			let returnRoute = this.$route.path + '?promotion_id=' + this.listDetail.promotion_id;
			sessionStorage.setItem("returnRoute", returnRoute);
			this.$router.push('/orders-sales/orders/detail/' + orderId)
		}

	}
}
</script>

<style lang="scss" scoped>
</style>
